import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class LightsPanel extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.lightOnCount = 0;
    this.lights = [];

    const background = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height / 2, UIAssetKeys._ProgressBarDays, this).setOrigin(0);

    // lights off
    for (let i = 0; i < 10; i++) {
      const lightOff = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2 + 60 + (i * 57), this.scene.scale.height / 2 + 4, `ProgressBar${i + 1}Days`, this).setOrigin(0);
    }

    // lights on
    for (let i = 0; i < 10; i++) {
      const lightOn = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2 + 60 + (i * 57), this.scene.scale.height / 2 + 4, `ProgressBar${i + 1}HighlightDays`, this).setOrigin(0);
      lightOn.alpha = 0;
      this.lights.push(lightOn);
    }
  }

  turnOnNextLight () {
    if (this.lightOnCount > 9) {
      return;
    }

    this.turnOnLight(this.lightOnCount);
    this.lightOnCount++;
  }

  turnOnLight (index) {
    const light = this.lights[index];
    light.alpha = 1;

    const delay = Phaser.Math.Between(1700, 3000);
    ABCyaPhaser.Tweens.addTween(light, delay, { alpha: 0.7, yoyo: true }, Phaser.Math.Easing.Linear);
  }
}